import { useEffect, useState } from 'react';
import { MARKET_EVENT, marketFromHash } from '../utils/market';
import type { Market } from '../types/content';

/** Market tab state that follows #commercial-painting / #residential-painting links. */
export function useMarketTab(initial: Market = 'commercial') {
  const [market, setMarket] = useState<Market>(initial);

  useEffect(() => {
    const fromHash = () => {
      const m = marketFromHash(window.location.hash);
      if (m) setMarket(m);
    };
    const fromEvent = (e: Event) => setMarket((e as CustomEvent<Market>).detail);
    fromHash();
    window.addEventListener('hashchange', fromHash);
    window.addEventListener(MARKET_EVENT, fromEvent);
    return () => {
      window.removeEventListener('hashchange', fromHash);
      window.removeEventListener(MARKET_EVENT, fromEvent);
    };
  }, []);

  return [market, setMarket] as const;
}
